import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { GoogleSheetsBaseService } from './google-sheets-base.service';

@Injectable({
  providedIn: 'root'
})
export class AttachmentSheetsService extends GoogleSheetsBaseService {

  /**
   * Gets a list of attachment types from the 'common' sheet.
   * @returns An observable of the attachment types.
   */
  getAttachmentTypes(): Observable<any> {
    const tabName = 'common';
    const startCell = 'A2';
    const endCell = 'A100';
    return this.getSheetData(tabName, startCell, endCell).pipe(
      map(response => response[0] || [])
    );
  }
}